export const CUSTOM_MIDDLE_RIGHT_CONTROL = 'custom-item-control-mr';
